import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

// const HEADER_HEIGHT = 64; // Set actual header height in px
const FOOTER_HEIGHT = 100; // Set actual footer height in px

const HomeLayout = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* <Box sx={{ position: "sticky", flexShrink: 0 }}>
        <Header />
      </Box> */}
      <Header />

      <Box
        sx={{
          flex: 1,
          px: 1,
          display: "flex",
          flexDirection: "column",
            minHeight: `calc(100vh - 74px - ${FOOTER_HEIGHT}px)`,
          overflowY: "auto",
        }}
      >
        <Outlet />
      </Box>

      <Box sx={{ flexShrink: 0 }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default HomeLayout;
